import React from 'react';
import bemHelper from 'react-bem-helper';

import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-additional-text' });

class AdditionalTextModule extends React.Component {

  render() {
    const { link, defaultLink, text, onClickFunction, classNames } = this.props;

    return (
      <div {...bem(null, classNames)}>
        <p {...bem('label')}>Please see notonthehighstreet.com's
          <a {...bem('link')} onClick={onClickFunction}
             href={`${link || defaultLink}`}> {text}</a>.</p>
      </div>
    );
  }
}

export default AdditionalTextModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/AdditionalTextModule/AdditionalTextModule.js